import { Injectable } from "@angular/core";
import { AppFormmetaModel } from "common/models/page-models/App_Model/app-form-meta.model";
import { AppModel } from "common/models/page-models/App_Model/app-form.model";
import { MetaModel } from "common/models/utility-models/base-model";
import { SystemService } from "common/services/core-services/system.service";
import { AppDataService } from "common/services/data-services/admin/app-service/app-data.service";
import { FormWidgetService } from "../form-widget.service";

@Injectable({
    providedIn: 'root'
})
export class AppWidgetService extends FormWidgetService<AppModel> {
    constructor(protected ds: AppDataService,
        private ss: SystemService,
    ) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new AppFormmetaModel();
        return meta.getMetaModel();
    }

    Save() {
        return new Promise((resolve, reject) => {
            this.ds
                .getDataOfAppState()
                .then((data:any) => {
                    //console.log(data);
                    
                    resolve(data);
                })
                .catch((error:any) => {
                    reject(error);
                });
        });
    }
}
